export default "__VITE_ASSET__BTWQBfC9__"